import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import Drawer from "components/Drawer";
import GeneralConfigDrawer from "components/GeneralConfig/GeneralConfigDrawer";
import {
	isAdmin,
	isSupervisor,
	hasSubscriptionFeature,
	isSupervisorWithEditShifts,
	isSupervisorWithEditPlanning,
} from "utils/utils";
import { isHaddockEnvironment } from "utils/documentUtils";

const SidebarConfig = (props) => {
	// console.log(props);
	const { user, t } = props;
	// console.log(user);

	const groups_supervised = user.groups_supervised;
	// const isSupervisorWithEditEmployees =
	// 	isSupervisor() &&
	// 	groups_supervised.length > 0 &&
	// 	groups_supervised.some((gs) => gs.edit_employees);
	const supervisorCanEditShifts = isSupervisorWithEditShifts(groups_supervised);
	const supervisorCanEditPlanning =
		isSupervisorWithEditPlanning(groups_supervised);

	const isSupervisorWithEditStaffing =
		isSupervisor() &&
		groups_supervised.length > 0 &&
		groups_supervised.some((gs) => gs.edit_staffing_levels);

	const isSupervisorWithEditGroups =
		isSupervisor() &&
		groups_supervised.length > 0 &&
		groups_supervised.some((gs) => gs.edit_groups);

	const showShiftsSection =
		isAdmin() || supervisorCanEditShifts || supervisorCanEditPlanning;
	const showShiftsLink = isAdmin() || supervisorCanEditShifts;
	const showShiftPatternsLink = isAdmin() || supervisorCanEditPlanning;
	const showStaffing =
		isAdmin() || isSupervisorWithEditStaffing || isSupervisorWithEditGroups;

	const hasPowersWithExpensesSubscription =
		(isAdmin() || isSupervisor()) && hasSubscriptionFeature("EXPENSES");

	const [generalConfigOpen, setGeneralConfigOpen] = React.useState(false);

	return (
		<aside className="sidebar-config" role="complementary">
			<ul className="menu-config">
				{isAdmin() && (
					<li>
						<h4 className="menu-section-title">
							<span className="option-text">{t("settings.general.title")}</span>
						</h4>
						<ul className="menu-sub">
							<li>
								<button
									type="button"
									className="menu-config-link menu-config-link--button"
									onClick={() => setGeneralConfigOpen(true)}
								>
									<span className="option-text">
										{t("generalConfigs.menuItem")}
									</span>
									<span className="badge-new">{t("common.new")}</span>
								</button>
							</li>
						</ul>
					</li>
				)}
				{isAdmin() && (
					<li>
						<h4 className="menu-section-title">
							<span className="option-text">{t("settings.employees.title")}</span>
						</h4>

						<ul className="menu-sub">
							<li>
								<NavLink to="/contracts" exact activeClassName="active">
									<span className="option-text">{t("settings.employees.contracts")}</span>
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/employee-functions"
									exact
									activeClassName="active"
								>
									<span className="option-text">{t("settings.employees.functions")}</span>
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/employee-ubications"
									exact
									activeClassName="active"
								>
									<span className="option-text">{t("settings.employees.locations")}</span>
								</NavLink>
							</li>
							<li>
								<NavLink to="/custom-fields" exact activeClassName="active">
									<span className="option-text">{t("settings.employees.customFields")}</span>
								</NavLink>
							</li>
						</ul>
					</li>
				)}
				{showShiftsSection && (
					<li>
						<h4 className="menu-section-title">
							<span className="option-text">{t("settings.shifts.title")}</span>
						</h4>
						<ul className="menu-sub">
							{showShiftsLink && (
								<li>
									<NavLink to="/shifts" exact activeClassName="active">
										<span className="option-text">{t("settings.shifts.shifts")}</span>
									</NavLink>
								</li>
							)}

							{showShiftPatternsLink && (
								<li>
									<NavLink to="/shift-patterns" exact activeClassName="active">
										<span className="option-text">{t("settings.shifts.shiftPatterns")}</span>
									</NavLink>
								</li>
							)}
							{isAdmin() && (
								<>
									<li>
										<NavLink to="/time-types" exact activeClassName="active">
											<span className="option-text">{t("settings.shifts.timeTypes")}</span>
										</NavLink>
									</li>

									<li>
										<NavLink to="/calendars" exact activeClassName="active">
											<span className="option-text">{t("settings.shifts.calendars")}</span>
										</NavLink>
									</li>
									{user?.company?.partner === true && (
										<li>
											<NavLink to="/calendars-system" exact activeClassName="active">
												<span className="option-text">{t("calendars.system.menu")}</span>
											</NavLink>
										</li>
									)}
									<li>
										<NavLink to="/day-types" exact activeClassName="active">
											<span className="option-text">{t("settings.shifts.dayTypes")}</span>
										</NavLink>
									</li>
								</>
							)}
						</ul>
					</li>
				)}

				{showStaffing && (
					<li>
						<h4 className="menu-section-title">
							<span className="option-text">{t("settings.groups.title")}</span>
						</h4>
						<ul className="menu-sub">
							{(isAdmin() || isSupervisorWithEditGroups) && (
								<li>
									<NavLink to="/groups" activeClassName="active">
										<span className="option-text">{t("settings.groups.groups")}</span>
									</NavLink>
								</li>
							)}

							<li>
								<NavLink to="/staffing-levels" exact activeClassName="active">
									<span className="option-text">{t("settings.groups.staffingLevels")}</span>
								</NavLink>
							</li>
						</ul>
					</li>
				)}

				{isAdmin() && (
					<li>
						<h4 className="menu-section-title">
							<span className="option-text">{t("settings.rules.title")}</span>
						</h4>

						<ul className="menu-sub">
							<li>
								<NavLink to="/rules" exact activeClassName="active">
									<span className="option-text">{t("settings.rules.rules")}</span>
								</NavLink>
							</li>
							<li>
								<NavLink to="/accounts" exact activeClassName="active">
									<span className="option-text">{t("settings.rules.accounts")}</span>
								</NavLink>
							</li>

							<li>
								<NavLink to="/transactions" exact activeClassName="active">
									<span className="option-text">{t("settings.rules.transactions")}</span>
								</NavLink>
							</li>
						</ul>
					</li>
				)}

				{hasPowersWithExpensesSubscription && !isHaddockEnvironment() && (
					<li>
						<h4 className="menu-section-title">
							<span className="option-text">{t("settings.expenses.managementTitle")}</span>
						</h4>

						<ul className="menu-sub">
							<li>
								<NavLink to="/providers" exact activeClassName="active">
									<span className="option-text">{t("settings.expenses.providers")}</span>
								</NavLink>
							</li>
							<li>
								<NavLink to="/expense-types" exact activeClassName="active">
									<span className="option-text">{t("settings.expenses.categories")}</span>
								</NavLink>
							</li>
							<li>
								<NavLink to="/payment-types" exact activeClassName="active">
									<span className="option-text">{t("settings.expenses.paymentMethods")}</span>
								</NavLink>
							</li>
						</ul>
					</li>
				)}

				{isAdmin() && (
					<li>
						<h4 className="menu-section-title">
							<span className="option-text">{t("settings.integrations.title")}</span>
						</h4>

						<ul className="menu-sub">
							<li>
								<NavLink
									to="/integrations"
									exact
									activeClassName="active"
									className="menu-config-link--with-badge"
								>
									<span className="option-text">{t("settings.integrations.link")}</span>
									<span className="badge-new">{t("common.new")}</span>
								</NavLink>
							</li>
						</ul>
					</li>
				)}

			</ul>

			{generalConfigOpen && (
				<Drawer
					isOpen={generalConfigOpen}
					onClose={() => setGeneralConfigOpen(false)}
					width={640}
				>
					<GeneralConfigDrawer
						handleClose={() => setGeneralConfigOpen(false)}
					/>
				</Drawer>
			)}
		</aside>
	);
};

const mapStateToProps = (state) => {
	// console.log(state);
	return {
		user: state.authReducer.user,
	};
};

export default connect(mapStateToProps, null)(withRouter(withTranslation()(SidebarConfig)));
